export default class InputValidators {
  static lengthValidator(value) {
    if (!value || value.length === 0) {
      return 'validation_errors.length'
    }

    return null
  }

  static emailValidator(value) {
    if (
      value &&
      value.length >= 1 &&
      // eslint-disable-next-line
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value,
      )
    ) {
      return 'validation_errors.email'
    }
    return InputValidators.lengthValidator(value)
  }

  static postalCodeValidator(value) {
    if (!value) {
      return InputValidators.lengthValidator(value)
    }

    const noRightFormat =
      value.length >= 1 &&
      !/^0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}$/.test(value)
    if (noRightFormat || value.length > 5) {
      return 'validation_errors.postal_code'
    }

    return InputValidators.lengthValidator(value)
  }
}
